import { render, staticRenderFns } from "./serviceList.vue?vue&type=template&id=16cb89ea&scoped=true"
import script from "./serviceList.vue?vue&type=script&lang=js"
export * from "./serviceList.vue?vue&type=script&lang=js"
import style0 from "./serviceList.vue?vue&type=style&index=0&id=16cb89ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cb89ea",
  null
  
)

export default component.exports